<script setup>
// [xleaders] XO-07 — gửi lời mời kết bạn Zalo từ số điện thoại đã có trên hồ sơ khách.
// Dựng theo khuôn VoiceCallButton.vue: tự ẩn khi không dùng được, tự chọn inbox khi có nhiều.
import { computed, ref, useAttrs } from 'vue';
import { useMapGetter } from 'dashboard/composables/store';
import { useZaloFriendRequest } from 'dashboard/composables/useZaloFriendRequest';
import { INBOX_TYPES } from 'dashboard/helper/inbox';

import Button from 'dashboard/components-next/button/Button.vue';
import Dialog from 'dashboard/components-next/dialog/Dialog.vue';

const props = defineProps({
  phone: { type: String, default: '' },
  contactId: { type: [String, Number], required: true },
  tooltipLabel: { type: String, default: '' },
});

defineOptions({ inheritAttrs: false });
const attrs = useAttrs();
const { isSending, sendFriendRequest } = useZaloFriendRequest();

const dialogRef = ref(null);

const inboxesList = useMapGetter('inboxes/getInboxes');
const zaloInboxes = computed(() =>
  (inboxesList.value || []).filter(
    inbox => inbox.channel_type === INBOX_TYPES.ZALO_PERSONAL
  )
);

// Không có kênh Zalo cá nhân, hoặc khách chưa có số → không có gì để bấm.
const shouldRender = computed(
  () => zaloInboxes.value.length > 0 && !!props.phone
);

const onClick = () => {
  if (isSending.value) return;
  if (zaloInboxes.value.length > 1) {
    dialogRef.value?.open();
    return;
  }
  sendFriendRequest(zaloInboxes.value[0].id, { contact_id: props.contactId });
};

const onPickInbox = inbox => {
  dialogRef.value?.close();
  sendFriendRequest(inbox.id, { contact_id: props.contactId });
};
</script>

<template>
  <span class="contents">
    <Button
      v-if="shouldRender"
      v-tooltip.top-end="tooltipLabel || $t('CONTACT_PANEL.ZALO_FRIEND.BUTTON')"
      v-bind="attrs"
      :is-loading="isSending"
      :disabled="isSending"
      icon="i-ph-user-plus"
      @click="onClick"
    />

    <Dialog
      v-if="shouldRender && zaloInboxes.length > 1"
      ref="dialogRef"
      :title="$t('CONTACT_PANEL.ZALO_FRIEND.INBOX_PICKER_TITLE')"
      show-cancel-button
      :show-confirm-button="false"
      width="md"
    >
      <div class="flex flex-col gap-2">
        <button
          v-for="inbox in zaloInboxes"
          :key="inbox.id"
          type="button"
          class="flex items-center gap-2 w-full px-4 py-2 text-left rounded-lg hover:bg-n-alpha-2"
          @click="onPickInbox(inbox)"
        >
          <span class="i-ph-user-plus text-n-slate-10" />
          <span class="text-sm text-n-slate-12">{{ inbox.name }}</span>
        </button>
      </div>
    </Dialog>
  </span>
</template>
